import styled from 'styled-components';

const Wrapper = styled.div`
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-top: 2rem;
    flex-wrap: wrap;
  }

  .page-btn {
    min-width: 2.25rem;
    height: 2.25rem;
    padding: 0 0.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    color: #374151;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .page-btn:hover:not(:disabled) {
    border-color: var(--clr-olive, #6b7b5c);
    color: var(--clr-olive, #6b7b5c);
  }

  .page-btn.active {
    background: var(--clr-olive, #6b7b5c);
    border-color: var(--clr-olive, #6b7b5c);
    color: #ffffff;
  }

  .page-btn:disabled {
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .ellipsis {
    color: #9ca3af;
    padding: 0 0.25rem;
  }
`;

export default Wrapper;
